import React, { useState, useRef, useEffect } from "react";

import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  Tabs,
  Tab,
  useMediaQuery,
  Select,
  MenuItem,
  Checkbox,
  InputLabel,
  FormControl,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import QRCodeStyling from "qr-code-styling";
import Bg1 from "../../../Assets/img/Virtual/bg-1.jpg";
import Bg2 from "../../../Assets/img/Virtual/bg-2.jpg";
import Bg3 from "../../../Assets/img/Virtual/bg-3.jpg";
import Bg4 from "../../../Assets/img/Virtual/bg-4.jpg";
import Bg5 from "../../../Assets/img/Virtual/bg-5.jpg";
import Bg6 from "../../../Assets/img/Virtual/bg-6.jpg";
import Bg7 from "../../../Assets/img/Virtual/bg-7.jpg";
import Bg8 from "../../../Assets/img/Virtual/bg-8.jpg";
import Bg10 from "../../../Assets/img/Virtual/bg-10.jpg";
import Bg9 from "../../../Assets/img/Virtual/bg-9.jpg";
import Default_Image from "../../../Assets/img/Virtual/Default_Image.jpg";
import upload from "../../../Assets/img/Virtual/upload.jpg";
import axios from "axios";
import useApi from "../../Utilities/useAPI";

const colors = [
  "#000000",
  "#ff4d4d",
  "#ffa500",
  "#008000",
  "#0000ff",
  "#800080",
];

const Virtual = () => {
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [tabIndex, setTabIndex] = useState(0);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedBackground, setSelectedBackground] = useState(null);
  const qrCodeRef = useRef(null);
  const qrCode = useRef(null);
  const [data, setData] = useState([]);
  const [qrLoading, setQrLoading] = useState(true);
  const [qrOption, setQrOption] = useState("Personal");
  const [logoUrl, setLogoUrl] = useState(null);
  const [displayData, setDisplayData] = useState({
    name: "",
    company: "",
    jobTitle: "",
    location: "",
  });
  const [showOptions, setShowOptions] = useState({
    name: false,
    company: false,
    jobTitle: false,
    location: false,
  });
  const isTablet = useMediaQuery("(max-width: 900px)");
  const { callApiFunction } = useApi();
  const objectId = localStorage.getItem("objectId");
  const apiKey = process.env.REACT_APP_API_KEY;
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  console.log("dataNNN", data);

  useEffect(() => {
    setQrLoading(true);
    try {
      qrCode.current = new QRCodeStyling({
        width: 100,
        height: 100,
        data: `${process.env.REACT_APP_CARD_URL}/digital-identity/${qrOption}/${objectId}`,
        dotsOptions: {
          color: selectedColor,
          type: "square",
          width: 4,
        },
        backgroundOptions: {
          color: "#ffffff",
        },
        cornersSquareOptions: {
          type: "square",
          color: selectedColor,
        },
        cornersDotOptions: {
          type: "square",
          color: selectedColor,
        },
        qrOptions: {
          errorCorrectionLevel: "H",
          quality: 1.0,
          mode: "Byte",
        },
      });

      if (qrCodeRef.current) {
        qrCodeRef.current.innerHTML = "";
        qrCode.current.append(qrCodeRef.current);
      }
      setQrLoading(false);
    } catch (error) {
      console.error("QR Code initialization error:", error);
      setQrLoading(false);
    }
  }, [qrOption, selectedColor]);

  // useEffect(() => {
  //   let url = `${process.env.REACT_APP_CARD_URL}/digital-identity/${qrOption}/${objectId}`;
  //   if (qrCode.current) {
  //     qrCode.current.update({
  //       data: url,
  //       image: logoUrl, // Update only the logoUrl
  //     });
  //   }
  // }, [logoUrl]); // This will run only when logoUrl changes

  useEffect(() => {
    // Function to run on mount and update
    const fetchData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/usercontact/virtualbackground`,
        {
          headers: headers,
        }
      );
      const { first_name, institute, field_of_study, city } =
        response.data.data;
      setDisplayData({
        name: first_name || "",
        company: institute || "",
        jobTitle: field_of_study || "",
        location: city || "",
      });

      // console.log("res virtual", response);

      setData(response.data.data);
    };

    fetchData();
  }, []);

  const handleCheckboxChange = (field) => {
    setShowOptions((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const defaultImage = Default_Image;

  const backgroundImages = [Bg1, Bg2, Bg3, Bg4, Bg5, Bg6, Bg7, Bg8, Bg9, Bg10];

  const resizeImage = (imageUrl) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = imageUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = 1920;
        canvas.height = 1080;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const resizedImageUrl = canvas.toDataURL("image/png");
        resolve(resizedImageUrl); // Return resized image URL for use in download
      };
    });
  };

  const handleBackgroundSelect = async (imageUrl) => {
    setSelectedBackground(imageUrl); // Set preview image immediately

    // Resize and set the uploaded image asynchronously
    const resizedImageUrl = await resizeImage(imageUrl);
    setUploadedImage(resizedImageUrl);
  };

  const renderTextOverlay = () => {
    const parts = [];
    if (showOptions.jobTitle) {
      if (qrOption === "Professional") {
        parts.push(data.designation);
        if (showOptions.company) parts.push(`@ ${data.profession_department}`);
      } else if (qrOption === "Student") {
        parts.push(data.field_of_study);
        if (showOptions.company) parts.push(`@ ${data.institute}`);
      }
    }
    const line1 = parts.length ? parts.join(" ") : null;
    const line2 = showOptions.location ? displayData.location : "";

    return (
      <>
        {showOptions.name && displayData.name && (
          <Typography className="virtual-text-name" sx={{ fontSize: "9px" }}>
            {displayData.name}
          </Typography>
        )}
        {line1 && (
          <Typography
            className="virtual-text-profession"
            sx={{ fontSize: "6px", width: "18vw" }}
          >
            {line1}
          </Typography>
        )}
        {line2 && (
          <Typography sx={{ fontSize: "9px" }} className="virtual-text-place">
            {line2}
          </Typography>
        )}
      </>
    );
  };

  useEffect(() => {
    if (qrCodeRef.current && qrCode.current) {
      qrCodeRef.current.innerHTML = "";
      qrCode.current.append(qrCodeRef.current);
      qrCode.current.update({ dotsOptions: { color: selectedColor } });
    }

    return () => {
      if (qrCodeRef.current) {
        qrCodeRef.current.innerHTML = "";
      }
    };
  }, [selectedColor]);

  const handleDownload = async () => {
  const canvas = document.createElement("canvas");
  canvas.width = 1920;
  canvas.height = 1080;
  const context = canvas.getContext("2d");

  const backgroundImage = new Image();
  backgroundImage.crossOrigin = "anonymous";
  backgroundImage.src = selectedBackground || defaultImage;

  if (!qrCode.current) {
    console.error("QR code is not initialized.");
    return;
  }

  try {
    if (typeof qrCode.current.getRawData !== "function") {
      throw new Error("getRawData method is not available on qrCode.current");
    }

    // Retrieve QR code image as a blob
    const qrCodeImageBlob = await qrCode.current.getRawData("png");
    const qrCodeImage = new Image();
    qrCodeImage.src = URL.createObjectURL(qrCodeImageBlob);

    // Prepare to load the logo image if available
    const logoImage = new Image();
    if (logoUrl) {
      logoImage.crossOrigin = "anonymous";
      logoImage.src = logoUrl;
    }

    // Load all images before drawing
    await Promise.all([
      new Promise((resolve) => (backgroundImage.onload = resolve)),
      new Promise((resolve) => (qrCodeImage.onload = resolve)),
      logoUrl
        ? new Promise((resolve) => (logoImage.onload = resolve))
        : Promise.resolve(),
    ]);

    // Draw the background image
    context.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);

    // Draw the logo if available
    if (logoUrl) {
      const logoWidth = 100;
      const logoHeight = 100;
      const logoX = canvas.width - logoWidth - 40; // Position from left
      const logoY = 40; // Position from top
      
      // Draw logo with white border
      context.save();
      context.globalAlpha = 0.6;
      context.shadowColor = 'white';
      context.shadowBlur = 10;
      context.drawImage(logoImage, logoX, logoY, logoWidth, logoHeight);
      context.restore();
    }

    // Draw text overlays based on showOptions
    context.font = "bold 40px Arial";
    context.fillStyle = "white";
    context.textAlign = "left";
    let yPosition = logoUrl ? 160 : 50; // Adjust starting position based on logo presence

    if (showOptions.name && displayData.name) {
      context.fillText(displayData.name, 40, yPosition);
      yPosition += 50;
    }

    const jobAndCompany = [
      showOptions.jobTitle ? 
        (qrOption === "Professional" ? data.designation : data.field_of_study) : "",
      showOptions.company ? 
        `@ ${qrOption === "Professional" ? data.profession_department : data.institute}` : "",
    ]
      .filter(Boolean)
      .join(" ");

    if (jobAndCompany) {
      context.font = "30px Arial"; // Smaller font for job title
      context.fillText(jobAndCompany, 40, yPosition);
      yPosition += 50;
    }

    if (showOptions.location && displayData.location) {
      context.fillText(displayData.location, 40, yPosition);
    }

    // Draw the QR code image
    context.drawImage(
      qrCodeImage,
      canvas.width - 220,
      canvas.height - 220,
      200,
      200
    );

    canvas.toBlob((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "background.png";
      link.click();
      URL.revokeObjectURL(link.href);
    }, "image/png");
  } catch (error) {
    console.error("Error generating QR code:", error);
  }
};

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUploadedImage(imageUrl); // Set the uploaded image directly for preview
      setSelectedBackground(imageUrl); // Set the uploaded image as background
    }
  };

  const ImageUpload = ({ handleImageUpload }) => {
    const handleClick = () => {
      document.getElementById("fileInput").click();
    };

    return (
      <Box className="virtual-upload-box">
        <input
          id="fileInput"
          type="file"
          onChange={handleImageUpload}
          accept="image/*"
          style={{ display: "none" }} // Hide the input
        />
        <img
          src={upload}
          alt="Upload"
          onClick={handleClick}
          width={50}
          height={50}
          className="virtual-upload-image"
        />
      </Box>
    );
  };

  const handleSelectTag = (value) => {
    const selectedCard = data.card_names?.find(
      (card) => card.card_type.toLowerCase() === value.toLowerCase()
    );
    setLogoUrl(selectedCard?.logo || null);
  };

  return (
    // <div className="home-page-container">

    <div className="home-page-container p-3 ">
      <div
        className="p-4"
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxshadow: "5px 4px 8px rgba(0, 0, 0, 0.7)",
        }}
      >
        <Box className="virtual-main-box">
          <Box className="virtual-box">
            <Box className="virtual-box-flex">
              <Typography variant="h6" className="virtual-text-name-2 ">
                Choose QR Color
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row", // Ensures items are arranged in a row
                  gap: 2, // Adds spacing between buttons
                }}
              >
                {colors.map((color, index) => (
                  <IconButton
                    key={index}
                    onClick={() => setSelectedColor(color)}
                    className="d-flex flex-row"
                    sx={{
                      width: 25,
                      height: 25,
                      backgroundColor: color,
                      border:
                        selectedColor === color ? "2px solid #000" : "none",
                      borderRadius: "50%",
                      padding: "5px",
                    }}
                  />
                ))}
              </Box>
              {/* {colors.map((color, index) => (
              <IconButton
                key={index}
                onClick={() => setSelectedColor(color)}
                className="d-flex flex-row"
                sx={{
                  width: 25,
                  height: 25,
                  backgroundColor: color,
                  border: selectedColor === color ? "2px solid #000" : "none",
                  borderRadius: "50%",
                  padding: "5px",
                }}
              />
              

            ))} */}
            </Box>
            <Typography variant="h6" className="virtual-Customize-Background">
              Customize Your Background
            </Typography>
            <Box className="virtual-select-checkBox">
              <div>
                <label>
                  {/* <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange("name")}
                />{" "} */}
                  <Checkbox onChange={() => handleCheckboxChange("name")} />
                  Name
                </label>
              </div>
              <div>
                <label>
                  {/* <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange("company")}
                />{" "} */}
                  <Checkbox onChange={() => handleCheckboxChange("company")} />
                  Company / Organization
                </label>
              </div>
              <div>
                <label>
                  {/* <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange("jobTitle")}
                />{" "} */}
                  <Checkbox onChange={() => handleCheckboxChange("jobTitle")} />
                  Job Title / Field of study
                </label>
              </div>
              <div>
                <label>
                  {/* <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange("location")}
                />{" "} */}
                  <Checkbox onChange={() => handleCheckboxChange("location")} />
                  City
                </label>
              </div>
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  mt: 2,
                  width: "100%",
                  textAlign: "left",
                  mb: "5px",
                  color: "gray",
                  fontSize: "12px",
                }}
              >
                Customize Your QR Code
              </Typography>

              <div style={{ textAlign: "left", mt: "10px", marginTop: "20px" }}>
                <FormControl>
                  <InputLabel id="demo-simple-select-helper-label">
                    QR Option
                  </InputLabel>
                  <Select
                    value={qrOption}
                    label="QR Option"
                    // InputLabelProps={{
                    //   shrink: true, // This forces the label to stay shrunk even when the field is empty
                    // }}
                    InputProps={{
                      readOnly: true, // Make the TextField read-only
                    }}
                    onChange={(e) => {
                      setQrOption(e.target.value);
                      handleSelectTag(e.target.value); // Update logo based on selected card type
                    }}
                    sx={{ width: "300px", marginBottom: 2 }}
                  >
                    <MenuItem
                      value="Student"
                      onChange={() => handleSelectTag("Student")}
                    >
                      Student
                    </MenuItem>
                    <MenuItem
                      value="Personal"
                      onChange={() => handleSelectTag("Personal")}
                    >
                      Personal
                    </MenuItem>
                    <MenuItem
                      value="Professional"
                      onChange={() => handleSelectTag("Professional")}
                    >
                      Professional
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                }}
              >
                <Tabs
                  value={tabIndex}
                  onChange={handleTabChange}
                  // sx={{ backgroundColor: "#f0f0f0", width: "100%" }}
                  sx={{
                    width: "100%",
                    "& .MuiTab-root": { color: "#aaa", textTransform: "none" }, // Default tab color
                    "& .Mui-selected": { color: "#0044c6", fontWeight: "bold" }, // Selected tab color
                    "& .MuiTabs-indicator": { backgroundColor: "#0044c6" }, // Indicator color
                  }}
                >
                  <Tab
                    label="Choose From Gallery"
                    sx={{
                      textTransform: "none",
                      color: tabIndex === 0 ? "#0044c6" : "#555",
                      width: "50%",
                    }}
                  />
                  <Tab
                    label="Upload From Your Own"
                    sx={{
                      textTransform: "none",
                      color: tabIndex === 1 ? "#0044c6" : "#555",
                      width: "50%",
                    }}
                  />
                </Tabs>
              </Box>
              {tabIndex === 0 && (
                <Box sx={{ mt: 2 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: isTablet
                        ? "repeat(2, 1fr)" // Adjust for tablet screens
                        : "repeat(3, 1fr)", // Default for larger screens
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    {backgroundImages.map((image, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          width: "210px",
                          height: "100px",
                          "&:hover button": {
                            display: "block",
                          },
                        }}
                      >
                        <img
                          src={image}
                          alt={`background-${index}`}
                          className="virtual-background-image"
                        />
                        <Button
                          // class="vitual-btn"
                          sx={{
                            position: "absolute",
                            bottom: "10px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            display: "none",
                            backgroundColor: "#0044c6",
                            borderRadius: "4px",
                          }}
                          variant="contained"
                          color="primary"
                          onClick={() => handleBackgroundSelect(image)}
                        >
                          Select
                        </Button>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
              {tabIndex === 1 && (
                <Box sx={{ mt: 2, width: "100%" }}>
                  <Box
                    sx={{
                      height: "120px",
                      width: "650px",
                      border: "1px dashed",
                      borderColor: "gray",
                      borderRadius: "4px",
                      padding: "16px",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        textAlign: "center",
                        // width: "100%",
                        // Ensures it spans the full width of the container
                      }}
                    >
                      <Box>
                        <ImageUpload
                          handleImageUpload={handleImageUpload}
                          width="10"
                          height="10"
                        />
                      </Box>
                      <h5 style={{ color: "gray" }}>Select image to upload</h5>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>

          <Box sx={{ position: "relative", paddingTop: "10px" }}>
            <Typography
              variant="h6"
              sx={{
                // width: "100%",
                textAlign: "left",
                mb: "10px",
                // mt: "-80px",
                color: "gray",
                fontSize: "20px",
              }}
            >
              Virtual background preview
            </Typography>
            <Box sx={{ position: "relative" }}>
              <img
                src={selectedBackground || defaultImage}
                alt="Uploaded"
                style={{
                  width: "580px",
                  borderRadius: "4px",
                }}
              />
              {logoUrl && (
                <img
                  src={logoUrl}
                  alt="Logo"
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    width: "50px",
                    height: "50px",
                    objectFit: "contain",
                    opacity: 0.6,
                    borderRadius: "5px",
                    border: "2px solid white",
                  }}
                />
              )}
              <Box
                sx={{
                  position: "absolute",
                  top: 10,
                  left: 10,
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                {renderTextOverlay()}
              </Box>
              <Box
                ref={qrCodeRef}
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
                  opacity: qrLoading ? 0.5 : 1,
                  transition: "opacity 0.3s ease",
                  "& canvas": {
                    display: "block", // Removes any default spacing
                  },
                }}
              ></Box>

              {qrLoading && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "#0044c6",
                  }}
                >
                  Loading...
                </Box>
              )}
            </Box>

            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
              sx={{
                mt: 4,
                width: "60%",
                ml: "20%",
                fontSize: "12px",
                backgroundColor: "#0044c6",
                borderRadius: "4px",
                color: "white",
                py: 1,
                "&:hover": {
                  backgroundColor: "#003399", // Darker shade of #0044c6
                  color: "white",
                },
              }}
            >
              Download Background
            </Button>
          </Box>
        </Box>
      </div>

      {/* </Container> */}
    </div>

    // </div >
  );
};
export default Virtual;
